<div class="contents">
   <img src="assets/2022/imgs/onlinelook/icon_inform@2x.png" alt="">
   <div class="content">
      汇集“智慧校园”“教学创新”“数字资源”三大类15家具有代表性的“教育数字化转型”应用场景展示学校，用全新技术手段，更好地展示上海市教育信息化应用标杆培育校数字化转型的应用成果。
   </div>
</div>
<div class="pic">
   <img src="/assets/2022/imgs/onlinelook/experience_pic2@2x.jpg" alt="">
</div>
